import React, { useState, useContext, useEffect } from 'react';
import CONFIG from "config";
import { AppActions } from 'store';
import { StateContext, DispatchContext } from 'context';
import './main.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faPlane } from '@fortawesome/free-solid-svg-icons';
import 'pure-react-carousel/dist/react-carousel.es.css';
import { Themes } from 'styles';
import { Header } from 'app/header';
// import { BuscadorExterno } from 'app/buscador-externo';
import { Contacto } from 'app/contacto';
import { Footer } from 'app/footer';
import { SelectorTema } from 'app/selector-thema';
import { Link as SMLink, Button, Element as SMElement, Events as SMEvents, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll';
import useScrollPosition from '@react-hook/window-scroll';
import { Inicio } from 'app/inicio';
import { MessengerChat } from 'react-messenger-chat-plugin';
import { Routes, Route} from "react-router-dom";
import { Nosotros } from 'app/nosotros';
import { Prestamos } from 'app/prestamos';
import { DescuentoDeCheques } from 'app/descuento-de-cheques';
import { CreditosDeTurismo } from 'app/creditos-de-turismo';
import { AsociacionesDeEmpleados } from 'app/asociaciones-de-empleados';
import { SolicitudDePrestamo } from 'app/solicitud-de-prestamo';
import { UnipersonalEmpresa } from 'app/unipersonal-empresa';
import { SolicitudDescuentoDeCheques } from 'app/solicitud-descuento-de-cheques';

const Main = props => {
    const scrollY = useScrollPosition(60);
    const dispatch = useContext(DispatchContext);
    const state = useContext(StateContext);
    const indexTema = state && state.appReducer && state.appReducer.indexTema ? state.appReducer.indexTema : 0;
    const [imagenesListas, setImagenesListas] = useState(false);
    useEffect(() => {
        dispatch(AppActions.setLoading(false));
        dispatch(AppActions.setActionsDisabled(false));
        document.title = 'SERFIN S.A.';



        // SMEvents.scrollEvent.register('begin', function (to, element) {
        //     console.log('begin', arguments);
        // });

        // SMEvents.scrollEvent.register('end', function (to, element) {
        //     console.log('end', arguments);
        // });

        // scrollSpy.update();


    }, []);

    const cargaImagenes = (imagenes) => {
        var cantImgs = imagenes.length;
        var cargadas = 0;
        function loadImgs() {
            cargadas = cargadas + 1;
            if (cargadas === cantImgs) {
                setImagenesListas(true);
            }
        };
        if (cantImgs > 0) {
            for (let i in imagenes) {
                let image = new Image();
                image.src = CONFIG.URL_BASE + imagenes[i].imagen;
                image.onload = function () {
                    loadImgs();
                };
            }
        } else {
            setImagenesListas(true);
        }
    }

    const scrollear = (target) => {
        let offs = (target === 'inicio') ? 0 : -100;
        scroller.scrollTo(target, {
            duration: 1000,
            delay: 100,
            smooth: true,
            offset: offs, // Scrolls to element + 50 pixels down the page
        })
    }
    
    const scrollTop = () => {
        scroll.scrollToTop();
    }

    return (
        <div className="bs-bbox" style={{overflow: 'hidden'}}>
            {/* <MessengerChat pageId='102483696457238' language='es_ES' /> */}
            {/* <SelectorTema /> */}
            {scrollY && scrollY > 300 ? <button className="w3-btn grow boton-scroll-top"
                onClick={() => scrollTop()}
                style={{ backgroundColor: Themes[indexTema].TH }}><FontAwesomeIcon size="1x" icon={faArrowUp} color="#fff"></FontAwesomeIcon></button> : null}

            <Header scrollear={scrollear} scrollTop={scrollTop} />
            {/* <SMElement name="inicio">
                <Inicio />
            </SMElement> */}
            <Routes>
                <Route path="/" element={<Inicio scrollTop={scrollTop} />} />
                <Route path="/nosotros" element={<Nosotros />} />
                <Route path="/prestamos" element={<Prestamos />} />
                <Route path="/descuento-de-cheques" element={<DescuentoDeCheques />} />
                <Route path="/creditos-de-turismo" element={<CreditosDeTurismo />} />
                <Route path="/unipersonal-empresa" element={<UnipersonalEmpresa />} />
                <Route path="/asociaciones-de-empleados" element={<AsociacionesDeEmpleados />} />
                <Route path="/solicitud-de-prestamo" element={<SolicitudDePrestamo />} />
                <Route path="/solicitud-descuento-de-cheques" element={<SolicitudDescuentoDeCheques />} />
            </Routes>
            <SMElement name="contacto">
                <Contacto />
            </SMElement>
            <Footer />
        </div>
    );
}
export default Main;